<template>
  <div>
    <v-btn icon :class="$style.toggleButton" @click="apiOverviewModal = true">
      <v-icon :class="$style[rating]"> mdi-alert </v-icon>
    </v-btn>

    <v-dialog v-model="apiOverviewModal" scrollable max-width="1200px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
          <h2>
            Api-Overview <strong>{{ environment }}</strong>
          </h2>
          <v-icon @click="apiOverviewModal = false">mdi-close</v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-expansion-panels>
            <v-expansion-panel v-for="(group, groupName) in groupedEnvList" :key="groupName">
              <v-expansion-panel-header>
                <v-row>
                  <v-col class="d-flex align-center">
                    <h4 class="ma-0" :class="getRatingClass(group.serviceRating)">
                      <v-icon class="mr-4" :class="$style.icon">mdi-send</v-icon
                      >{{ $t(`apiInstances.${groupName}`) }}
                    </h4>
                  </v-col>
                  <v-col class="d-flex flex-column justify-center">
                    <dl class="my-2 dl-list">
                      <template v-for="item in group.items">
                        <dt :key="`${item.id}-dt`" class="font-weight-bold">{{ item.subtype }}:</dt>
                        <dd :key="`${item.id}-dd`" :class="`${$style[item.rating]}`">
                          {{ $t(`apiInstances.stateDesc.${item.rating}`) }} ({{ item.value }})
                        </dd>
                      </template>
                    </dl>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-alert class="mb-0" text dense icon="mdi-information"
                  >{{ $t(`apiInstances.desc_${groupName}`) }}
                </v-alert>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { DP_ADMIN } from '@/js/helper/dp-admin-constants.js'
import { mapState, mapGetters } from 'vuex'
import APP_CONSTANTS from '@/js/plugins/store/modules/app/constants.js'
import APP_GETTER from '@/js/plugins/store/modules/app/getter-types.js'
import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'

export default {
  name: 'ApiOverviewInstances',
  data() {
    return {
      apiOverviewModal: false,
      adminConstants: DP_ADMIN,
    }
  },
  computed: {
    ...mapState(STOREMODULES.APP, {
      envData: APP_CONSTANTS.ENVIRONMENT_DATA,
    }),
    ...mapGetters(STOREMODULES.APP, {
      environment: APP_GETTER.ENVIRONMENT,
      environmentTypo3: APP_GETTER.ENVIRONMENT_TYPO3,
    }),
    envList() {
      return (this.envData?.env || [])
        .map(i => {
          const serviceArray = i.service.split('.')
          return {
            ...i,
            services: serviceArray.shift(),
            serviceNumber: serviceArray.join('.'),
          }
        })
        .filter(
          i =>
            i.service !== 'typo3' ||
            `${i.service}${i.serviceNumber ? `.${i.serviceNumber}` : ''}` === this.environmentTypo3,
        )
    },

    groupedEnvList() {
      const ratingOrder = ['unknown', 'test', 'warn', 'prod']

      const grouped = this.envList.reduce((acc, current) => {
        const group = current.service
        if (!acc[group]) {
          acc[group] = {
            serviceRating: '',
            items: [],
          }
        }

        acc[group].items.push(current)

        return acc
      }, {})

      for (const group in grouped) {
        const highestRating = this.getHighestRating(grouped[group].items, ratingOrder)
        grouped[group].serviceRating = highestRating
      }

      return grouped
    },

    rating() {
      return this.envList.reduce(
        (rating, item) => {
          const itemRatingSeverity = DP_ADMIN.FE_STAT_SEVERITY?.[item.rating]
          if (itemRatingSeverity && itemRatingSeverity > rating[1]) {
            return [item.rating, itemRatingSeverity]
          }
          return rating
        },
        [
          DP_ADMIN.FE_SERVICE_STAT_STATE_UNKNOWN,
          DP_ADMIN.FE_STAT_SEVERITY[DP_ADMIN.FE_SERVICE_STAT_STATE_UNKNOWN],
        ],
      )[0]
    },
  },

  methods: {
    getHighestRating(group, ratingOrder) {
      const ratings = group.map(item => item.rating)
      return ratings.reduce((highest, current) => {
        return ratingOrder.indexOf(current) > ratingOrder.indexOf(highest) ? current : highest
      }, 'unknown')
    },

    getRatingClass(rating) {
      return rating === DP_ADMIN.FE_SERVICE_STAT_STATE_PROD
        ? this.$style.prod
        : rating === DP_ADMIN.FE_SERVICE_STAT_STATE_WARN
        ? this.$style.warn
        : rating === DP_ADMIN.FE_SERVICE_STAT_STATE_UNKNOWN
        ? this.$style.prod
        : this.$style.test
    },
  },
}
</script>
<style lang="scss" module>
.fixed {
  position: fixed;
}

.icon {
  color: inherit !important;
}

.row {
  padding: 1rem 0;
}

.normal,
.test {
  color: #01cd01 !important;
}

.warn {
  color: #fcd700 !important;
}

.prod {
  color: red !important;
}

.toggleButton {
  color: var(--primary) !important;
}
</style>
